import React, {Component} from "react";
import {
    Table as BootstrapTable,
    Row,
    Col
}                         from "react-bootstrap";
import moment             from "moment";

import { IS_VALID }        from "utils";

export default class View extends Component {
    render () {
        let {
            selectedData
        } = this.props;

        const GET_VALUE = (key) => {
            if (IS_VALID(selectedData)) {
                let value = "";

                if (
                    key === "createdAt" ||
                    key === "updatedAt"
                ) {
                    value = moment(selectedData.get(key)).format("MMM DD, YYYY hh:mm A");
                } else if (
                    key === "createdBy" ||
                    key === "updatedBy"
                ) {
                    if (IS_VALID(selectedData.get(key))) {
                        value = selectedData.get(key).get("name") || "";
                    }
                } else if (IS_VALID(selectedData)) {
                    value = selectedData.get(key);
                }

                return value;
            } else {
                return "";
            }
        }

        return (
            <BootstrapTable
                bordered
                responsive
            >
                <tbody>
                    <tr>
                        <td>
                            <b>Title</b>
                        </td>
                        <td>{GET_VALUE("title")}</td>
                    </tr>
                    <tr>
                        <td>
                            <b>Browser</b>
                        </td>
                        <td>
                            {GET_VALUE("browser")}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <b>URL</b>
                        </td>
                        <td>
                            {GET_VALUE("url")}
                        </td>
                    </tr>
                    <tr>
                        <td>
                        <b>Content</b>
                        </td>
                        <td>
                            <div dangerouslySetInnerHTML={{__html: GET_VALUE("content")}}></div>
                        </td>
                    </tr>
                    <tr>
                        <td>
                        <b>Created At</b>
                        </td>
                        <td>{GET_VALUE("createdAt")}</td>
                    </tr>
                    <tr>
                        <td>
                        <b>Updated At</b>
                        </td>
                        <td>{GET_VALUE("updatedAt")}</td>
                    </tr>
                    <tr>
                        <td>
                        <b>Created By</b>
                        </td>
                        <td>{GET_VALUE("createdBy")}</td>
                    </tr>
                    <tr>
                        <td>
                        <b>Updated By</b>
                        </td>
                        <td>{GET_VALUE("updatedBy")}</td>
                    </tr>
                </tbody>
            </BootstrapTable>
        );
    }
}


// WEBPACK FOOTER //
// ./components/TierBlockMessage/FormContainer/View.js